var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{ref:"salaryBarLine",staticClass:"fchart-bi"},[_vm._v("工资发放情况")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aFlex fchart-box-top"},[_c('span',{staticClass:"ft-bold"},[_vm._v("工资发放情况")]),_c('span',{staticClass:"ft-gray",staticStyle:{"margin-left":"10px"}},[_vm._v("默认统计系统日期上个月")])])
}]

export { render, staticRenderFns }